import Vue from 'vue';
import { errorTypes, actionTypes } from '@/types';
import { logger } from '../tools/logger';

function clearQuestionFields() {
	const $articleWrapper = document.querySelector('.wrapper--article--current');
	$articleWrapper.querySelectorAll('.post--inputtext').forEach((post) => {
		post.querySelector('.element__input').value = '';
	});
	$articleWrapper.querySelectorAll('.post--textarea').forEach((post) => {
		post.querySelector('.element__textarea').value = '';
	});
	$articleWrapper
		.querySelectorAll('.post--rating, .post--multiplechoice, .post--singlechoice')
		.forEach((post) => {
			post.querySelectorAll('input').forEach((radio) => (radio.checked = false));
		});
	$articleWrapper.querySelectorAll('.post--rating').forEach((post) => {
		post.setAttribute('unanswered', true);
	});
}

function addSingleValue({ key, element, required, selected }, answers) {
	const inputField = element.querySelector(`input${selected ? ':checked' : ''}, textarea`);

	const value = inputField ? inputField.value || inputField.innerText || inputField.textContent || '' : '';
	answers[`${element.getAttribute('post-id')}|${key}`] = value;
	return required && value === '';
}
function addSelectionValues({ key, element, required }, answers) {
	const inputFields = element.querySelectorAll('input:checked');
	const checkedValues = [...inputFields].map((input) => {
		const key = input.value;
		const $label = element.querySelector(`label[for="${key}"]`);
		const humanReadableKey = $label.innerText || $label.textContent;
		return humanReadableKey;
	});

	answers[`${element.getAttribute('post-id')}|${key}`] = checkedValues.join(', ');
	return required && checkedValues.length === 0;
}
function sanitize(text = '') {
	return text.replace(/^\$|\./g, '·');
}
export async function sendForm({ state, dispatch }) {
	let incomplete = false;

	const data = {
		articleID: state.currentArticleID,
		webClientID: state.persistent.webClientID,
	};
	const answers = {};
	// meta data

	const $articleWrapper = document.querySelector('.wrapper--article--current');
	if ($articleWrapper.getAttribute('form-success') === 'true') {
		return;
	}
	$articleWrapper
		.querySelectorAll(
			'.post--inputtext, .post--textarea, .post--rating, .post--multiplechoice, .post--singlechoice'
		)
		.forEach(($question) => {
			const inputRequired = $question.getAttribute('input-required') === 'true';
			const $questionLabel = $question.querySelector('.element--text');
			// use label as human readable key for display of surveys in cms it has to be sanitized for using as db key
			const humanReadableKey = sanitize($questionLabel.innerText || $questionLabel.textConten);
			let inputMissing = false;
			if ($question.classList.contains('post--inputtext') || $question.classList.contains('post--textarea')) {
				inputMissing = addSingleValue(
					{ key: humanReadableKey, element: $question, required: inputRequired },
					answers
				);
			} else if ($question.classList.contains('post--rating')) {
				inputMissing = addSingleValue(
					{ key: humanReadableKey, element: $question, required: inputRequired, selected: true },
					answers
				);
			} else if (
				$question.classList.contains('post--singlechoice') ||
				$question.classList.contains('post--multiplechoice')
			) {
				inputMissing = addSelectionValues(
					{ key: humanReadableKey, element: $question, required: inputRequired },
					answers
				);
			}

			if (inputMissing) {
				$question.setAttribute('input-missing', true);
				incomplete = true;
			} else {
				$question.removeAttribute('input-missing');
			}
		});
	if (incomplete) {
		// stop
		incomplete = false;
		dispatch(actionTypes.sendErrorMessage, { error: new Error(errorTypes.formIncomplete) });
		return;
	}

	const hostURL = new URL(state.dataSourceURL);
	let postURL =
		hostURL.hostname.includes('staging.shoutrlabs') || hostURL.hostname.includes('localhost')
			? 'https://staging.shoutrlabs.com/survey'
			: 'https://cms.shoutrlabs.com/survey';

	data.data = answers;
	$articleWrapper.setAttribute('form-success', true);
	try {
		await Vue.http.post(postURL, data);
	} catch (error) {
		logger.error(error);
		$articleWrapper.removeAttribute('form-success');
		dispatch(actionTypes.sendErrorMessage, { error: new Error(errorTypes.formSendError) });
	}

	clearQuestionFields();
}
